<app-header-content-help-text [Heading]="'Materials page'" [helpText]="'A complete master for Product Attributes'"></app-header-content-help-text>
<app-material-organism></app-material-organism>
